import { render, staticRenderFns } from "./PrivateTreatyActions.vue?vue&type=template&id=32c1eeac&scoped=true&"
import script from "./PrivateTreatyActions.vue?vue&type=script&lang=js&"
export * from "./PrivateTreatyActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c1eeac",
  null
  
)

export default component.exports